import axiosInstance from '../config/axios.js';

const DB = '/dashboard';

const dashboardService = {
  // ── Consolidated dashboard endpoints ─────────────────────────

  getUsers: async () => {
    const response = await axiosInstance.get(`${DB}/users`);
    return response.data;
  },

  getVehicles: async () => {
    const response = await axiosInstance.get(`${DB}/vehicles`);
    return response.data;
  },

  getShipments: async (params = {}) => {
    const response = await axiosInstance.get(`${DB}/shipments`, { params });
    return response.data;
  },

  getPayments: async (params = {}) => {
    const response = await axiosInstance.get(`${DB}/payments`, { params });
    return response.data;
  },

  getAttendance: async (params = {}) => {
    const response = await axiosInstance.get(`${DB}/attendance`, { params });
    return response.data;
  },

  getCommissions: async (params = {}) => {
    const response = await axiosInstance.get(`${DB}/commissions`, { params });
    return response.data;
  },

  getOnContracts: async (params = {}) => {
    const response = await axiosInstance.get(`${DB}/on-contracts`, { params });
    return response.data;
  },

  getTripContracts: async (params = {}) => {
    const response = await axiosInstance.get(`${DB}/trip-contracts`, { params });
    return response.data;
  },

  getSalaries: async (params = {}) => {
    const response = await axiosInstance.get(`${DB}/salaries`, { params });
    return response.data;
  },

  getMlAgentDues: async (params = {}) => {
    const response = await axiosInstance.get(`${DB}/ml-agent-dues`, { params });
    return response.data;
  },

  getCargoOverview: async (params = {}) => {
    const response = await axiosInstance.get(`${DB}/cargo-overview`, { params });
    return response.data;
  },

  getCargoDrilldown: async (params = {}) => {
    const response = await axiosInstance.get(`${DB}/cargo-overview/drilldown`, { params });
    return response.data;
  },

  getLocationTargets: async (params = {}) => {
    const response = await axiosInstance.get(`${DB}/location-targets`, { params });
    return response.data;
  },

  saveLocationTarget: async (body, params = {}) => {
    const response = await axiosInstance.put(`${DB}/location-targets`, body, { params });
    return response.data;
  },

  getLocationTargetContributors: async (locationHubId, params = {}) => {
    const response = await axiosInstance.get(
      `${DB}/location-targets/${locationHubId}/contributors`,
      { params },
    );
    return response.data;
  },

  getCargoVehicleSuggestion: async (params = {}) => {
    const response = await axiosInstance.get(`${DB}/cargo-overview/vehicle-suggestion`, { params });
    return response.data;
  },

  getBookingSummary: async (params = {}) => {
    const response = await axiosInstance.get(`${DB}/booking-summary`, { params });
    return response.data;
  },

  searchShipments: async (q, params = {}) => {
    const response = await axiosInstance.get(`${DB}/shipment-search`, {
      params: { q, ...params },
    });
    return response.data;
  },

  getOwner: async (params = {}) => {
    const response = await axiosInstance.get(`${DB}/owner`, { params });
    return response.data;
  },

  getMasterDashboard: async (params = {}) => {
    const response = await axiosInstance.get(`${DB}/master`, { params });
    return response.data;
  },

  getAllCompanies: async () => {
    const response = await axiosInstance.get('/company');
    return response.data;
  },
};

export default dashboardService;
